const testimonials = [
  {
    name: "Karen S.",
    location: "Cape Coral, FL",
    rating: 5,
    text: "We had a family cruise to the Bahamas booked for spring break and my daughter's passport had expired. I found out three weeks before we were supposed to leave. Fast Passport Center walked me through the child passport process, caught that my ex-husband's consent form had the wrong date, and got all three of our passports back with five days to spare. I honestly thought we would lose the entire trip.",
    service: "Child Passport Renewal",
  },
  {
    name: "Robert M.",
    location: "Fort Myers, FL",
    rating: 5,
    text: "I am a Twins season ticket holder from Minnesota and I keep a condo in Fort Myers for spring training. Every March I drive up to Toronto for a few road games, and this year I pulled out my passport the night before my flight and saw it had expired two months ago. I called Fast Passport Center in a panic on a Thursday. They had my renewal processed and back to me by Tuesday morning. I made my flight.",
    service: "Passport Renewal",
  },
  {
    name: "Diana L.",
    location: "Sanibel, FL",
    rating: 5,
    text: "My husband and I planned a Costa Rica eco-tour for our 40th anniversary. We booked it six months ago through a travel agent but never checked our passports. Three weeks before departure, we realized both had expired. Fast Passport Center handled both renewals simultaneously, caught a photo issue on mine before submission, and we had our passports back with a full week to spare. The trip was absolutely magical.",
    service: "Couple's Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function FortMyersTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Lee County Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Fort Myers, Cape Coral, and Sanibel travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}